<template>

    <div class="modal fade" id="filters-modal" tabindex="-1" aria-labelledby="createprojectlLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title fw-bold" id="createprojectlLabel">Φίλτρα</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <small>Χρησιμοποιώντας το αστεράκι (*) σε μια λέξη (πχ: Νικ* ή *Νικ*) μπορείτε να αναζητήσετε περιεχόμενο που την περιλαμβάνει.</small>
                    <div class="mb-3 mt-2">
                        <label for="name" class="form-label" aria-label="name" aria-placeholder="Name">Name</label>
                        <input type="text" class="form-control" name="name" id="name" v-model="filterData.name">
                    </div>
                    <div class="mb-3">
                      <label class="form-label" aria-label="client" aria-placeholder="Client">Client</label>
                      <Select2 :options="allData.clients" v-model="filterData.clientId" :settings="select2Settings" />
                    </div>
                    <div class="mb-3">
                      <label class="form-label" aria-label="supplier" aria-placeholder="Supplier">Supplier</label>
                      <Select2 :options="allData.suppliers" v-model="filterData.supplierId" :settings="select2Settings" />
                    </div>
                    <div class="mb-3">
                        <label for="phone" class="form-label" aria-label="phone" aria-placeholder="phone">Phone</label>
                        <input type="text" class="form-control" name="phone" id="phone" v-model="filterData.phone">
                    </div>
                    <div class="mb-3">
                        <label for="email" class="form-label" aria-label="email" aria-placeholder="email">Email</label>
                        <input type="text" class="form-control" name="email" id="email" v-model="filterData.email">
                    </div>
                    <div class="mb-3">
                        <label for="postal" class="form-label" aria-label="postal" aria-placeholder="postal">Postal</label>
                        <input type="text" class="form-control" name="address" id="postal" v-model="filterData.postal">
                    </div>
                   
                    <div class="mb-3">
                        <label for="afm" class="form-label" aria-label="postal" aria-placeholder="afm">ΑΦΜ</label>
                        <input type="text" class="form-control" name="afm" id="afm" v-model="filterData.afm">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-secondary" @click="clearFilters">Καθαρισμός φίλτρων</button>
                    <button type="button" class="btn btn-secondary" @click="applyFilters">Εφαρμογή φίλτρων</button>
                </div>
            </div>
        </div>
    </div>

  <div class="table-container">
    <!-- Column Selection Dropdown -->
    <div class="d-flex justify-content-end mb-1">
      <!-- <div class="col-md-4"> -->
        <!-- <label class="mb-1">Selected Columns:</label> -->
        <!-- <select v-model="selectedColumns" multiple style="min-height:200px">
          <option v-for="col in columns" :key="col.value" :value="col.value">
            {{ col.label }}
          </option>
        </select> -->
        <!-- <Select2 v-model="selectedColumns" :options="columns.map(col => ({ id: col.value, text: col.label }))"
          :settings="select2Settings" :multiple="true" class="form-control" /> -->
      <!-- </div> -->
       <div class="mt-2" style="margin-right: 10px; margin-top: 5px;">Σύνολο επαφών: {{ count }}</div>
       <div><button class="btn btn-dark me-1 mt-1"  @click="showFilters" style="background-color: var(--secondary-color)"><i class="wx-ic wx-ic-filter" title="Archive"></i>
       </button></div>
      <!-- <div class="dropdown " @click="toggleDropdown" @blur="closeDropdown" tabindex="0">
        <button class="ms-2 me-2 mt-5 ms-sm-3 btn btn-primary dropdown-menu-toggler" type="button"
          style="color:var(--secondary-color); font-weight:bold">
          <i class="wx-ic wx-ic-trash" title="Archive"></i>
        </button>
        <ul class="dropdown-menu border-0 shadow p-3 " :class="{ 'show': isDropdownOpen }" :style="dropdownStyle">
          <li><a class="dropdown-item py-2 rounded archiveSelected" href="#"
              @click.prevent="showConfirmationModal">Αρχειοθέτηση
              επιλεγμένων</a></li>
        </ul>
      </div> -->
    </div>

    <!-- Table -->
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0 mis_table">
        <thead>
          <tr>
            <!-- <th>
              <div>
                <input type="checkbox" id="checkAllToggle" @click="toggleSelectAll" />
              </div>
            </th> -->
              <th ><input type="checkbox" @change="toggleSelectAll" :checked="allSelected" /></th>

            <th v-for="col in filteredColumns" :key="col">
              <div>
                {{ getLabel(col) }}
                <!-- <i class="fa fa-sort sorting-icon" @click.prevent="handleSortBy(col)"></i> -->
              </div>
            </th>
          
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in data" :key="index">
            <!-- <td><input type="checkbox" :value="row.id" v-model="selectedIds" /></td> -->
             <td>
<input
  type="checkbox"
  :checked="selectedIds.includes(row.id)"
  @change="() => onCheckboxChange(row.id)"
/>
              </td>
            <td v-for="col in filteredColumns" :key="col">
              <template v-if="isLinkColumn(col)">
                <router-link :to="{ path: tableOptions.singlePagePath, query: { id: row.id } }">
                  {{ row[col] }}
                </router-link>
              </template>
              <template v-else>
                <span @click="handleClick(col, row)">
                  {{ row[col] }}
                </span>
              </template>
            </td>
          
          </tr>
        </tbody>
      </table>
    </div>
    <nav aria-label="Page navigation" v-if="data && data.length">
      <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
        <li class="page-item" v-for="(paginationLink, index) in paginationLinks" :key="index"
          :class="{ active: paginationLink.active }">
          <router-link
  :to="{ 
    path: tableOptions.path, 
    query: { 
      id: route.query.id,         // ✅ Add this line to keep ID
      page: getPageFromUrl(paginationLink.url) 
    } 
  }"
  v-if="paginationLink.url"
>
  <span class="page-link" v-html="paginationLink.label"></span>
</router-link>

          <span class="page-link" v-else v-html="paginationLink.label"></span>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted, toRef } from "vue";
import { create } from "@/services/quicknote";
import Select2 from "vue3-select2-component";
import { useToast } from "vue-toastification";
import { getClientsServicesStatusesUsers } from "@/services/projects";
import { useRoute } from "vue-router";

export default {
  components: {
    Select2,
  },
  props: {
    columns: Array, // Example: [{ value: "name", label: "Name", isLink: true, linkField: "profileUrl" }]
    data: Array, // Example: [{ name: "John", profileUrl: "/profile/john" }]
    customHandler: Function, // Function to handle clicks
    tableOptions: Object,
    archiveContacts: Function,
    paginationLinks: Array,
    sortBy: Function,
    isLinkColumn: Function,
    refreshTable: Function,
    applyFilters: Function,
    count: Number,
    selectedIds: Array,
  },
  data() {
    return {
      select2Settings: { multiple: true },
    };
  },
  setup(props, { emit }) {
    const allData = ref({suppliers: [], clients: []});
    const selectedColumns = ref(props.columns.map(col => col.value));
     const selectedIds = toRef(props, 'selectedIds');
    const allSelected = computed(() => {
  return props.data && props.data.length > 0 && selectedIds.value.length === props.data.length;
});




    const isDropdownOpen = ref(false);
    const selectedContact = ref(null);
    const note = ref('');
    const notes = ref([]);
    const filterData = ref({});


    const dropdownStyle = computed(() => ({
      top: isDropdownOpen.value ? '100%' : 'initial',
      right: isDropdownOpen.value ? '0' : 'initial'
    }));

    const route = useRoute();

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const closeDropdown = () => {
      isDropdownOpen.value = false;
    };

    watch(selectedColumns, (newVal) => {
      localStorage.setItem("selectedColumns", JSON.stringify(newVal));
    });

    const storedColumns = localStorage.getItem("selectedColumnsContacts");
    if (storedColumns) {
      selectedColumns.value = JSON.parse(storedColumns);
    }

    const filteredColumns = computed(() => selectedColumns.value);

    const showFilters = () => {
        $("#filters-modal").modal('show');
    };

    const getLabel = (value) => {
      const column = props.columns.find(col => col.value === value);
      return column ? column.label : value;
    };

    const isLinkColumn = (value) => {
      return props.isLinkColumn(value);
    };

    const getLinkField = (value) => {
      const column = props.columns.find(col => col.value === value);
      return column?.linkField || value;
    };

    // Handle Click Events
    const handleClick = (column, row) => {
      if (props.customHandler) {
        props.customHandler(column, row);
      } else {
        emit("row-clicked", { column, row });
      }
    };

    const showConfirmationModal = () => {
      $("#delete-contacts-form").modal('show');
    };

    const handleArchiveContacts = () => {
      props.archiveContacts(selectedIds.value);
      $("#delete-contacts-form").modal('hide');
    }

    const getPageFromUrl = (url) => {
      if (!url) return null;
      const urlObj = new URL(url, window.location.origin);
      return urlObj.searchParams.get('page');
    };

    // Handle Sort By
    const handleSortBy = (column) => {
      props.sortBy(column);
    };

    const openQuickNoteForm = (row) => {
      selectedContact.value = row;
      $("#create-quicknote-form").modal('show');
    };

    const submitQuickNoteForm = async () => {
      const response = await create(selectedContact.value.id, { note: note.value });
      if (response.data.success) {
        props.refreshTable();
        useToast().success(response.data.message);
        note.value = '';
        $("#create-quicknote-form").modal('hide');
      } else {
        useToast().error(response.data.message);
      }
    };
    
    const applyFilters = () => {
        props.applyFilters(filterData.value);
        $("#filters-modal").modal('hide');
    };

    const showNotes = (row) => {
      notes.value = row.notes;
      $("#show-notes").modal('show');
    };

   const toggleSelectAll = () => {
  if (selectedIds.value.length === props.data.length) {
    emit("update:selectedIds", []);
  } else {
    emit("update:selectedIds", props.data.map(d => d.id));
  }
};

const onCheckboxChange = (id) => {
  const newIds = [...selectedIds.value];
  if (newIds.includes(id)) {
    newIds.splice(newIds.indexOf(id), 1);
  } else {
    newIds.push(id);
  }
  emit("update:selectedIds", newIds);
};



    const select2Settings = {
        dropdownParent: '#filters-modal .modal-content',
        placeholder: "Please select"
    };

    onMounted(async () => {
      const tmpAllData = await getClientsServicesStatusesUsers();

      let newData = {clients: [], suppliers: []};

      for (let i = 0; i < tmpAllData.data.clients.length; i++) {
          newData.clients.push({id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title});
      }
      for (let i = 0; i < tmpAllData.data.suppliers.length; i++) {
          newData.suppliers.push({id: tmpAllData.data.suppliers[i].id, text: tmpAllData.data.suppliers[i].title});
      }
      allData.value = newData;
    });

    const clearFilters = () => {
      filterData.value = {};
      props.applyFilters({});
      $("#filters-modal").modal('hide');
    };

    return { route, clearFilters, select2Settings, allData, applyFilters, showFilters, filterData, showConfirmationModal, notes, note, showNotes, submitQuickNoteForm, openQuickNoteForm, handleArchiveContacts, toggleSelectAll, dropdownStyle, closeDropdown, toggleDropdown, isDropdownOpen, handleSortBy, selectedIds, allSelected, selectedColumns, filteredColumns, getLabel, isLinkColumn, getLinkField, handleClick, getPageFromUrl, onCheckboxChange };
  },
};
</script>

<style scoped>
.table-container {
  margin-top: 0;
}

.column-selection {
  margin-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  background-color: #f4f4f4;
}

.link {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.clickable {
  cursor: pointer;
  color: #007bff;
}

.clickable:hover {
  text-decoration: underline;
}
</style>
